import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface CoacheeProfileDocumentsState {
	readonly reloadDocumentsTrigger: number;
	readonly documentsChunkSize: number;
	readonly documentsOffset: number;
	readonly documentsId: string[];
}

@Injectable()
export class CoacheeProfileDocumentsStore extends Store<CoacheeProfileDocumentsState> {
	constructor() {
		super(
			{ documentsId: [], documentsChunkSize: 20, documentsOffset: 0 },
			{ name: `ui-coachee-profile-documents-${guid()}` }
		);
	}
}
